import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownTrigger } from './components/DropdownTrigger';
import { DropdownWithAnyContent } from './DropdownWithAnyContent';
export const DropdownButtonWithAnyContent = (_a) => {
    var { children, variant } = _a, props = __rest(_a, ["children", "variant"]);
    return (_jsx(DropdownWithAnyContent, Object.assign({}, props, { children: ({ isOpen }) => (_jsx(DropdownTrigger, { isDisabled: props.isDisabled, isFullWidth: props.isFullWidth, isOpen: isOpen, variant: variant, children: children })) })));
};
//# sourceMappingURL=DropdownButtonWithAnyContent.js.map